export const TEXTING_OVERRIDES = {};
